import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_REPORT = `${BASE_URL}/api/v1/file`;
const DOWNLOAD_REPORT_BYTES_URL = `${BASE_URL_REPORT}/download/bytes`;

const fileService = {
    async loadFileInfo(uuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(
                `${BASE_URL}/api/v1/file/file-info/${uuid}`
            );
            return response.data;
        } catch (error) {
            console.error("Error loadFileInfo", error);
            throw error;
        }
    },

    async uploadFile(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/file/upload-file`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save upload file", error);
            throw error;
        }
    },

    async download(uuid: any, fileName: any): Promise<any> {
        try {
            const token = localStorage.getItem("access_token");
            const response = await apiClient.get<any>(
                `${BASE_URL}/api/v1/file/download/${uuid}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    responseType: 'blob',
                }
            );

            const blob = new Blob([response.data], {
                type: 'application/pdf',
            });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);

            return response.data;
        } catch (error) {
            console.error("Error save upload file", error);
            throw error;
        }
    },

    async deleteFileById(fileId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/file/file/${fileId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteFileById student social group", error);
            throw error;
        }
    },

    async downloadFileBytes(
        token: string,
        fileId: string
    ): Promise<any> {
        try {
            const response = await apiClient.get<any>(
                `${DOWNLOAD_REPORT_BYTES_URL}/${fileId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    responseType: 'blob' as 'json'
                }
            )
            return response.data;
        } catch (error) {
            console.error("Error on download:", error);
            throw error;
        }
    }
}

export async function convertFileBytesToBase64(fileBytes: Uint8Array): Promise<string> {
    return new Promise((resolve, reject) => {
        const blob = new Blob([fileBytes]);
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64data = reader.result;

            if (typeof base64data === 'string') {
                const base64String = base64data.split(',')[1];
                resolve(base64String);
            } else {
                reject(new Error('Failed to convert file to base64 string'));
            }
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(blob);
    });
}

export default fileService;